import { apiProxyRequest, apiProxyRequestFresh } from "Api/apiProxyRequest";

import { getDeploymentNextUrl } from "./utils";

import type { DeploymentRequestProps, Deployment } from "./types";

export const loadDeploymentNextRequest = ({
  projectId,
  environmentId,
  verbose,
  fresh
}: DeploymentRequestProps) => {
  const url = getDeploymentNextUrl({ projectId, environmentId, verbose });

  return fresh
    ? apiProxyRequestFresh<Deployment>(url)
    : apiProxyRequest<Deployment>(url);
};
